import script from "./ReviewProjectUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewProjectUserModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewProjectUserModal.vue?vue&type=style&index=0&id=dd803ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd803ad2"]])

export default __exports__